import React from 'react';

const DirectionsIcon = ({ ...rest }) => {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clipPath="url(#clip0_5301_1569)">
        <g opacity="0.2">
          <path fillRule="evenodd" clipRule="evenodd" d="M11.8787 10.8787C12.4413 10.3161 13.2044 10 14 10H32C32.7957 10 33.5587 10.3161 34.1213 10.8787C34.6839 11.4413 35 12.2043 35 13V31C35 31.7957 34.6839 32.5587 34.1213 33.1213C33.5587 33.6839 32.7957 34 32 34H14C13.2043 34 12.4413 33.6839 11.8787 33.1213C11.3161 32.5587 11 31.7957 11 31V13C11 12.2044 11.3161 11.4413 11.8787 10.8787ZM25.0486 15.1515C24.5799 14.6828 23.8201 14.6828 23.3515 15.1515C22.8829 15.6201 22.8829 16.3799 23.3515 16.8485L25.503 19H17.6C16.9373 19 16.4 19.5373 16.4 20.2C16.4 20.8627 16.9373 21.4 17.6 21.4H28.4C28.8854 21.4 29.323 21.1076 29.5087 20.6592C29.6944 20.2108 29.5918 19.6947 29.2486 19.3515L25.0486 15.1515ZM17.6 22.6C17.1147 22.6 16.6771 22.8924 16.4914 23.3408C16.3056 23.7892 16.4083 24.3053 16.7515 24.6485L20.9515 28.8485C21.4201 29.3172 22.1799 29.3172 22.6486 28.8485C23.1172 28.3799 23.1172 27.6201 22.6486 27.1515L20.4971 25H28.4C29.0628 25 29.6 24.4627 29.6 23.8C29.6 23.1373 29.0628 22.6 28.4 22.6H17.6Z" fill="currentColor"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5301_1569">
          <rect width="44" height="44" rx="12" fill="currentColor"/>
        </clipPath>
      </defs>
    </svg>

  );
};

export default DirectionsIcon;